// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"72d73fa9","667":"b9bd7085","977":"cb5a8db0"}[chunkId] + ".chunk.js";
};